import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="integer-input"
export default class extends Controller {
  filterInput(event) {
    const input = event.target;
    const value = input.value;
    const filteredValue = value.replace(/[^0-9]/g, '');

    if (value !== filteredValue) {
      input.value = filteredValue;
    }
  }
}
